import {LeadEventApiDto, LeadIncomingSmsEventDataApiDto} from "../../../api/model/rest";
import LeadEvent, {LeadEventTypeEnum} from "./LeadEvent";
import AuthenticatedEntity from "../../user/AuthenticatedEntity";
import {Icon} from "../../../hiberUiKit/src/atoms/Icon/Icon";
import {IconColor} from "../../../hiberUiKit/src/molecules/StreamItem/StreamItemIcon";
import moment = require("moment");

export default class LeadIncomingSmsEvent extends LeadEvent {
	/**
	 * @param {string} id identifier of event.
	 * @param {string} leadId lead id.
	 * @param {LeadEventTypeEnum} type type of the event.
	 * @param {AuthenticatedEntity} entity entity which creates the event.
	 * @param {moment.Moment} creationDate creation date of event.
	 * @param {string} referenceNumber lead reference number.
	 * @param data sms send event data
	 */
	constructor(public readonly id: string,
		public readonly leadId: string,
		public readonly type: LeadEventTypeEnum,
		public readonly entity: AuthenticatedEntity,
		public readonly creationDate: moment.Moment,
		public readonly referenceNumber: string,
		public readonly data: LeadIncomingSmsEventData) {
		super(id, leadId, type, entity, creationDate, referenceNumber);
	}

	public static fromJson(json: LeadEventApiDto): LeadIncomingSmsEvent {
		const data = LeadIncomingSmsEventData.fromJson(json.data as LeadIncomingSmsEventDataApiDto);
		const entity = AuthenticatedEntity.fromJson(json.entity);
		return new LeadIncomingSmsEvent(json.id, json.leadId, LeadEventTypeEnum.IncomingSms, entity, moment(json.createdAt),
			json.referenceNumber, data);
	}

	getIcon() {
		return Icon.SMS;
	}

	getIconColor(): IconColor {
		return IconColor.Burgundy;
	}

	getActivityType(): string {
		return `SMS`
	}

	getActivityMessage(): string {
		return `Incoming SMS - ${this.data.contactFullName}`;
	}

	getActivityAdditionalMessages(): string[] {
		return [`Message: ${this.data.message}`];
	}
}

export class LeadIncomingSmsEventData {
	constructor(public readonly message: string,
		public readonly subtype: string,
		public readonly phoneNumber: string,
		public readonly contactFullName: string,
		public readonly contactId: string) {}

	public static fromJson(json: LeadIncomingSmsEventDataApiDto): LeadIncomingSmsEventData {
		return new LeadIncomingSmsEventData(json.message, json.subtype, json.phoneNumber, json.contactFullName, json.contactId);
	}
}